module.exports = __webpack_public_path__ + "img/240-azores-islands.48b7fbe8.svg";